// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.inquiry.HpApiInquiryV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type { HpApiResponseDto, HpInquiryPrefillDto, HpInquiryRequestDto, HpInquiryResponseDto } from '../..';

export const HpApiInquiryV3Handler_create_Path = '/api/web/v3/user/inquiry/create';

/**
 * Submit a listing inquiry; the inquirer email is taken from the authenticated session
 */
export const HpApiInquiryV3Handler_create = (postData: HpInquiryRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpInquiryRequestDto, HpApiResponseDto<HpInquiryResponseDto>>(
    {
      endpoint: HpApiInquiryV3Handler_create_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiInquiryV3Handler_prefill_Path = '/api/web/v3/user/inquiry/prefill';

/**
 * Prefill the contact form from the user's renter profile and most recent inquiry
 */
export const HpApiInquiryV3Handler_prefill = (client = getClient()) => {
  return httpApiRequest<never, never, HpApiResponseDto<HpInquiryPrefillDto>>(
    {
      endpoint: HpApiInquiryV3Handler_prefill_Path,
      method: 'GET',
      contextPath: '/hotpads-api',
    },
    client,
  );
};
